/**
 * Describes the status of a step of an executing process.
 */
export enum ProcessStepStatusEnum {
	/**
	 * The step has not yet started.
	 */
	NotStarted = 1,

	/**
	 * The step is currently in progress.
	 */
	InProgress = 2,

	/**
	 * The step is complete.
	 */
	Complete = 3
}